import { Injectable } from '@angular/core';

/**
 * Loads third-party scripts on demand instead of from index.html, so a visitor only contacts
 * Google, Apple or Facebook when they use the feature that needs it (see docs/cookie-consent.md).
 */
@Injectable({ providedIn: 'root' })
export class ScriptLoaderService {

  private readonly loading = new Map<string, Promise<void>>();

  /** Appends one async `<script>` per src and resolves when it has run. A failed load is forgotten, so a later call retries. */
  public load(src: string): Promise<void> {
    let promise = this.loading.get(src);
    if (!promise) {
      promise = new Promise<void>((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.onload = () => resolve();
        script.onerror = () => {
          this.loading.delete(src);
          script.remove();
          reject(new Error(`Failed to load ${src}`));
        };
        document.head.appendChild(script);
      });
      this.loading.set(src, promise);
    }
    return promise;
  }
}
